export const formatPathname = (pathname: string) =>
  pathname.replace(/\/_sites\/\[[A-Za-z]*\]/g, '') || '/'

export const isHomePage = (formattedPathname: string) =>
  ['/', '/mint', '/mints'].indexOf(formattedPathname) !== -1

export const isMintPage = (formattedPathname: string) =>
  ['/mint', '/mints'].indexOf(formattedPathname) !== -1
